import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Document {
  name: string;
  api_token: string;
}

export interface DocumentDetaiInfor {
  errors: unknown;
  Document: Document;
  isAuthenticated: boolean;
}

@Module
export default class DocumentDetail
  extends VuexModule
  implements DocumentDetaiInfor
{
  errors = {};
  Document = {} as Document;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get DocumentDetail() {
    return this.documentDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.DOCUMENT_DETAIL_DATA](Document) {
    this.documentDetailData = Document;
  }
  @Action
  [Actions.DOCUMENT_DETAIL](payload) {
    return ApiService.getDataDetail("/document", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.DOCUMENT_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
